// composables/useNavigation.ts
import { useRouter } from 'vue-router'

export const useNavigation = () => {
  const router = useRouter()

  const goToLogin = () => router.push('/login')
  const goToHome = () => router.push('/')

  return {
    goToLogin,
    goToHome,
  }
}
